import PropTypes from 'prop-types';
import { portalNodeType } from '../util/sharedPropTypes';

export const imagePropTypes = PropTypes.shape({
  alt: PropTypes.string,
  focalPointLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  focalPointTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  url: PropTypes.string,
});

export const selectedOptionPropTypes = PropTypes.shape({
  groupKey: PropTypes.string,
  optionKey: PropTypes.string,
});

export const selectedRoomPropTypes = PropTypes.shape({
  roomCount: PropTypes.number.isRequired,
  roomKey: PropTypes.string.isRequired,
});

export const selectedFlightPropTypes = PropTypes.shape({
  flightClassKey: PropTypes.string,
  groupKey: PropTypes.string,
  optionKey: PropTypes.string,
});

export const selectedAccommodationPropTypes = PropTypes.shape({
  accommodationType: PropTypes.string,
  groupKey: PropTypes.string,
  optionKey: PropTypes.string,
  rooms: PropTypes.arrayOf(selectedRoomPropTypes),
});

export const selectedStopoverPropTypes = PropTypes.shape({
  groupKey: PropTypes.string,
  optionKey: PropTypes.string,
});

export const selectedOptionsPropTypes = PropTypes.shape({
  paxSelection: PropTypes.oneOfType([PropTypes.object, PropTypes.shape({})]),
  paxRuleKey: PropTypes.string,
  accommodationType: PropTypes.string,
  accommodations: PropTypes.arrayOf(selectedAccommodationPropTypes),
  excursions: PropTypes.arrayOf(selectedStopoverPropTypes),
  stopovers: PropTypes.arrayOf(selectedStopoverPropTypes),
  flights: PropTypes.arrayOf(selectedFlightPropTypes),
  tickets: PropTypes.arrayOf(selectedStopoverPropTypes),
  transports: PropTypes.arrayOf(selectedStopoverPropTypes),
});

export const progressBarStepPropTypes = PropTypes.shape({
  step: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  uri: PropTypes.string.isRequired,
});

const itinerarySideBarItemPropTypes = PropTypes.shape({
  content: PropTypes.string,
  key: PropTypes.string,
  type: PropTypes.string,
});

export const itinerarySideBarDayPropTypes = PropTypes.shape({
  date: PropTypes.string,
  day: PropTypes.number,
  items: PropTypes.arrayOf(itinerarySideBarItemPropTypes),
  key: PropTypes.string,
});

export const itinerarySideBarPropTypes = PropTypes.shape({
  bookNowButtonText: PropTypes.string,
  bookNowButtonUrl: PropTypes.string,
  buttonText: PropTypes.string,
  callToBookButtonText: PropTypes.string,
  costPerPerson: PropTypes.number,
  date: PropTypes.string,
  description: PropTypes.string,
  headerText: PropTypes.string,
  isCallToBook: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  itinerary: PropTypes.arrayOf(itinerarySideBarDayPropTypes),
  shareButtonText: PropTypes.string,
  shareEmailPackageBodyText: PropTypes.string,
  shareEmailPackageSubjectText: PropTypes.string,
  shareEmailPackageUrlLink: PropTypes.string,
  soldOutButtonText: PropTypes.string,
  title: PropTypes.string,
  tournament: PropTypes.string,
  waitingListLink: PropTypes.string,
  waitingListText: PropTypes.string,
});

export const contentPropTypes = PropTypes.shape({
  id: PropTypes.string,
  contentType: PropTypes.string,
  properties: PropTypes.shape({
    identifier: PropTypes.string,
    content: PropTypes.string,
    titleText: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string,
    text: PropTypes.string,
    image: imagePropTypes,
    reverse: PropTypes.bool,
    videoUrl: PropTypes.string,
    fallbackImage: imagePropTypes,
  }),
});

export const detailsModalPropTypes = {
  closeModalText: PropTypes.string,
  currencySymbol: PropTypes.string,
  images: PropTypes.arrayOf(imagePropTypes),
  title: PropTypes.string,
  subTitle: PropTypes.string,
  desc: PropTypes.string,
  content: PropTypes.arrayOf(contentPropTypes).isRequired,
  price: PropTypes.number,
  durationMin: PropTypes.number,
  durationMax: PropTypes.number,
  motorhomeBerthText: PropTypes.string,
  motorhomeGearboxText: PropTypes.string,
  motorhomeType: PropTypes.string,
  motorhomeTypeText: PropTypes.string,
  numberOfBerth: PropTypes.number,
  gearbox: PropTypes.string,
  priceFromText: PropTypes.string,
  viewDetailsCtaText: PropTypes.string,
  portalNode: portalNodeType.isRequired,
  maskMotorhomesAsCamping: PropTypes.bool,
};

export const linkPropTypes = PropTypes.shape({
  isNewWindow: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string,
});

export const fieldPropTypes = PropTypes.shape({
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  regex: PropTypes.shape(RegExp),
  value: PropTypes.string,
});

export const personNamePropTypes = PropTypes.shape({
  forename: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  prefix: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  surname: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
});

export const addressPropTypes = PropTypes.shape({
  addressLine1: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  addressLine2: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  addressLine3: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  city: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  county: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  postcode: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
});
